import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/basemap/enable/basemap.enable.mutation.gql"
import type {
  BasemapEnableMutation,
  BasemapEnableMutationVariables,
} from "@/v2-backoffice-client/basemap/enable/__types__/basemap.enable.mutation"

type Options = MutationHookOptions<
  BasemapEnableMutation,
  BasemapEnableMutationVariables
>

export function useBasemapEnableMutation(options?: Options) {
  return useMutation<BasemapEnableMutation, BasemapEnableMutationVariables>(
    mutation,
    options,
  )
}
